import React from 'react';

import Checkbox from '@components/checkbox/Checkbox.tsx';
import Icon from '@components/icon/Icon.tsx';
import Link from '@components/link/Link.tsx';
import getFormatPhone from '@functions/getFormatPhone.ts';
import getFormatPrice from '@functions/getFormatPrice.ts';
import getFormatedDate from '@functions/getFormatedDate.ts';
import getUserName from '@functions/getUserName.ts';
import { setCursorSupport } from '@functions/supportHandler.ts';
import KuperShiftT from '@global/models/KuperShift.ts';
import { CursorActionsItemT } from '@global/types.ts';

import More from '../components/More.tsx';

import { RenderColsT } from '../../types.ts';

const renderKuperShifts: RenderColsT<'kuperShifts'> = function ({ name: colName, item }) {
    const kuperShift = item as KuperShiftT;
    const { name, otherData, currentsHandler, currents } = this.props;

    let content;
    let className;
    const { dublicate } = kuperShift;

    if (colName === 'number') {
        content = (
            <>
                <div className="v2table__checkbox _COL">
                    {name === 'kuperShifts' && (
                        <>
                            <div className="v2table__checkboxBox">
                                <Checkbox
                                    name={kuperShift._id}
                                    value={
                                        !!currents!.find(
                                            (innerItem) => innerItem.id === kuperShift._id,
                                        )
                                    }
                                    onChange={() => {
                                        currentsHandler!(kuperShift._id, kuperShift);
                                    }}
                                />
                            </div>
                        </>
                    )}

                    <div className="v2table__text _block _selectAll">
                        {name === 'kuperShiftsCreatePays' && '№'}
                        {kuperShift.number}
                    </div>
                </div>
            </>
        );
    }

    if (colName === 'executor') {
        const ExecutorTag = kuperShift.exId ? Link : 'div';
        const exeucutorProps = kuperShift.exId
            ? { pageName: 'manual-executors-inner-main' as const, ids: { 3: kuperShift.exId } }
            : {};

        const dublicatesSupportProps = setCursorSupport(
            {
                _id: `dublicates-${kuperShift._id}`,
                content: 'Есть дубликаты',
                dir: 'top',
            },
            { targetClassName: '.v2table__textAlert', className: '' },
        );

        const renderDublicate = () =>
            dublicate &&
            kuperShift.status !== 'completed' && (
                <div className="v2table__textAlert" {...dublicatesSupportProps}>
                    <Icon name="alert" />
                </div>
            );

        content = (
            <>
                <ExecutorTag className={`v2table__text`} {...exeucutorProps}>
                    {kuperShift.executor ? (
                        <>
                            <p className="v2table__text _full _link">
                                {getUserName({ user: kuperShift.executor })}
                                {renderDublicate()}
                            </p>
                            <p className="v2table__text _block _grey">
                                {kuperShift.executor.phone}
                            </p>
                        </>
                    ) : (
                        <>
                            <p className="v2table__text _grey _selectAll _block">{kuperShift.kuperExId}</p>
                            <p className="v2table__text _selectAll">
                                {renderDublicate()} {kuperShift.exName}
                            </p>
                            ,{' '}
                            <p className="v2table__text _selectAll _noWrap">
                                {getFormatPhone({ phone: kuperShift.exPhone, withPlus: true })}
                            </p>
                        </>
                    )}
                </ExecutorTag>
            </>
        );
    }

    if (colName === 'amount') {
        content = (
            <>
                <div className="v2table__text _selectAll">
                    {getFormatPrice(+(+kuperShift.amount)?.toFixed(2))}&nbsp;₽
                </div>
            </>
        );
    }

    if (colName === 'date') {
        content = (
            <>
                <div className="v2table__text _block">
                    С {getFormatedDate({ date: new Date(kuperShift.startDate), isShortYear: true })}
                    <br />
                    по {getFormatedDate({ date: new Date(kuperShift.endDate), isShortYear: true })}
                </div>
            </>
        );
    }

    if (colName === 'status') {
        const getMoreActions = otherData?.getMoreActions as (data: {
            kuperShift: KuperShiftT;
        }) => CursorActionsItemT[];
        const statuses = {
            error: '_errorColor',
            success: '_processColor',
            completed: '_successColor',
        };
        const statusClassName = statuses[kuperShift.status];
        const supportProps =
            kuperShift.error &&
            setCursorSupport(
                { _id: `status-${kuperShift._id}`, content: kuperShift.errorText, dir: 'top' },
                {
                    targetClassName: '.v2table__textInfo',
                    className: '_upper',
                },
            );

        content = (
            <>
                <div className={`v2table__text _mediumWeight ${statusClassName}`}>
                    <div
                        className={`v2table__text _mediumWeight ${statusClassName}`}
                        dangerouslySetInnerHTML={{
                            __html: `${kuperShift.statusText} `.replace('\n', '<br/>'),
                        }}
                    ></div>
                    {kuperShift.error && (
                        <i className="v2table__textInfo _CLICK" {...supportProps}>
                            <Icon name="info" />
                        </i>
                    )}
                </div>
                <More id={`kuperShift-${kuperShift._id}`} items={getMoreActions({ kuperShift })} />
            </>
        );
    }

    return { content, className };
};

export default renderKuperShifts;
